import { useEffect, useRef, useState } from 'react';
import MembershipBalancePointLockEdit from './MembershipBalancePointLockEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../universal/columnshead';
import dayjs from 'dayjs';
import AntDraggableModal from '../../../utilsTsx/universal/AntDraggableModal';

const WebComponent = (props: any) => {
    const { closeModal, data } = props;
    const { membershipId } = data;
    const ref = useRef<any>(undefined);
    const apiId = 'membershipBalancePointLock';
    /** 后端数据defaultService */
    const [defaultService, setDefaultService] = useState<string>('');
    const [fethcData, setFethcData] = useState<any>();

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setDefaultService(urlService);
            setFethcData(() => ref.current.fetchData);
        }
    }, []);

    //表头
    const columnsHead = [
        {
            title: '会员',
            dataIndex: 'membership',
            render: (val: any) => val?.membershipInfo?.membershipName
        },
        {
            title: '锁定类型',
            dataIndex: 'lockAmountType',
            render: (val: any) => val?.name
        },
        {
            title: '锁定值',
            dataIndex: 'lockedAmount',
        },
        {
            title: '锁定截止期',
            dataIndex: 'expireDate',
            render: (text: any) => dayjs(text).format('YYYY-MM-DD HH:mm:ss')
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '会员余额积分锁定',
        apiId,
        columns,
        editOptions: {
            Editor: MembershipBalancePointLockEdit
        },
        sendPageData: {
            membershipId
        },
        serviceId: 'business'
    };

    return (
        <>
            <AntDraggableModal
                title={'会员余额积分锁定'}
                open={true}
                okText='确定'
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={closeModal}
                closable={false}
                maskClosable={false}
                width={1000} >
                <WebUniversal {...extendProps} ref={ref} />
            </AntDraggableModal>
        </>
    )
}

export default WebComponent;
